import { render, staticRenderFns } from "./ClientBillingEmailNotifications.vue?vue&type=template&id=2d5300e8&"
import script from "./ClientBillingEmailNotifications.vue?vue&type=script&lang=js&"
export * from "./ClientBillingEmailNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports